import React from 'react'
import styled from 'styled-components'

import { LinkItem } from './LinkItem'

export interface JumpToLinkCardItem {
  title: string
  description: string
  onSelect: () => void
  ariaLabel?: string
  disabled?: boolean
}

interface JumpToLinkCardsProps {
  items: JumpToLinkCardItem[]
}

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  width: 100%;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const JumpToLinkCards: React.FC<JumpToLinkCardsProps> = ({ items }) => {
  return (
    <CardsGrid>
      {items.map((item) => (
        <LinkItem key={item.title} {...item} />
      ))}
    </CardsGrid>
  )
}
